import { periodOptions } from '../helpers';

export const OutgoingsQuestions = {
  creditCommitments: {
    titleKey: 'affordabilityCalculator.outgoings.creditCommitments.title',
    subtitleKey: 'affordabilityCalculator.outgoings.creditCommitments.subtitle',
    unsecuredLoanRepayments: {
      titleKey: 'affordabilityCalculator.outgoings.creditCommitments.unsecuredLoanRepayments.title',
      textKey: 'affordabilityCalculator.outgoings.creditCommitments.unsecuredLoanRepayments.text',
    },
    securedLoanRepayments: {
      titleKey: 'affordabilityCalculator.outgoings.creditCommitments.securedLoanRepayments.title',
      textKey: 'affordabilityCalculator.outgoings.creditCommitments.securedLoanRepayments.text',
    },
    creditStoreCardsBalance: {
      titleKey: 'affordabilityCalculator.outgoings.creditCommitments.creditStoreCardsBalance.title',
      textKey: 'affordabilityCalculator.outgoings.creditCommitments.creditStoreCardsBalance.text',
    },
  },
  expenditure: {
    titleKey: 'affordabilityCalculator.outgoings.expenditure.title',
    childcare: {
      titleKey: 'affordabilityCalculator.outgoings.expenditure.childcare.title',
      textKey: 'affordabilityCalculator.outgoings.expenditure.childcare.text',
    },
    travelExpenses: {
      titleKey: 'affordabilityCalculator.outgoings.expenditure.travelExpenses.title',
      textKey: 'affordabilityCalculator.outgoings.expenditure.travelExpenses.text',
    },
    maintenance: {
      titleKey: 'affordabilityCalculator.outgoings.expenditure.maintenance.title',
      textKey: 'affordabilityCalculator.outgoings.expenditure.maintenance.text',
    },
    periodOptions,
  },
};
